/**
 * npm 源引入完整描述对象
 */
export function isProCodeComponentType(desc) {
  return 'package' in desc;
}
export function isLowCodeComponentType(desc) {
  return !isProCodeComponentType(desc);
}